// extracted by mini-css-extract-plugin
export default {"AvatarContainer":"Step3_AvatarContainer__9m+Fv","UploadButton":"Step3_UploadButton__hkifX"};